import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';

function leadFormAttributionFormatter({ action }) {
  return getGTMEventData(EVENT_NAMES.LEAD_FORM_ATTRIBUTION, action, {});
}

export default leadFormAttributionFormatter;
